import React from 'react';
import { Button } from 'beautiful-react-ui';


export default function Information({loadBouncy, loadJoystick}) {
    return (
        <div className="info-panel">
            <h2>What is TeaBlocks?</h2>
            <div className="info-block">An educational mobile app project for teaching kids to code through a node-base visual programming language and lessons</div>
            <h2>Instructions</h2>
            <div className="info-block">1. Select which node you want to add to the program</div>
            <div className="info-block">2. Click anywhere on the canvas to add the node</div>
            <div className="info-block">3. Connect node's by dragging the inputs to outputs</div>
            <div className="info-block">4. Press BUILD to compile your program, and press RUN to run it</div>
            <h2>Examples</h2>
            <div className="info-block">Demo programs made in TeaBlocks →</div>
            <Button color="primary" icon="upload" onClick={loadBouncy} className="compile-btn"> Load Bouncy Demo</Button>
            <Button color="primary" icon="upload" onClick={loadJoystick} className="compile-btn"> Load Joystick Demo</Button>
        </div>
    )
}
